import React from 'react';

import myImg from 'assets/images/MainLanding/my.svg';

export default function WhySection() {
  return (
    <section className="why-section">
      <div className="container">
        <div className="title my-title">
          <span>WHY</span>
          <img src={myImg} alt="" />
          <span>BASEPAY</span>
        </div>
      </div>

      <div className="wrapper bg-text-section">
        <span className="bg-text">WORLD CLASS</span>

        <div className="container section-content">
          <div className="row">
            <div className="col">
              <div className="badge">B</div>

              <div className="item-content">
                <div className="item-title">Boost</div>
                <div>
                  Your efficiency by delegating your{' '}
                  <span className="nowrap">back-office</span>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="badge">A</div>

              <div className="item-content">
                <div className="item-title">Automate</div>
                <div>Your recruiting processes</div>
              </div>
            </div>

            <div className="col">
              <div className="badge">S</div>

              <div className="item-content">
                <div className="item-title">Service</div>
                <div>
                  World-class, client-obsessive care for you & your customers
                </div>
              </div>
            </div>

            <div className="col">
              <div className="badge">E</div>

              <div className="item-content">
                <div className="item-title">Expand</div>
                <div>Your partner, candidate & client portfolio</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
